import { createStyles, makeUiStyles, Theme} from '../styles/styles';
import { TypographyFontWeightModel } from '../Typography/tools/Typography.model';
import { LabelProps } from './Label';
import { fontDisplay, fontDisplayExtraBold, FontSizeType, fontText, mapFontSizeTypeToLineHeight, StylesIndexInjections } from 'common-react';

const getFontStyle = (theme: Theme, size: FontSizeType | undefined, fontWeight: TypographyFontWeightModel) => {
  switch (fontWeight) {
    case 'normal':
      return fontText('normal', theme.fontSize[size || 'base'], mapFontSizeTypeToLineHeight(size));
    case 'bold':
      return fontDisplay('normal', theme.fontSize[size || 'base'], mapFontSizeTypeToLineHeight(size));
    case 'extraBold':
      return fontDisplayExtraBold('normal', theme.fontSize[size || 'base'], mapFontSizeTypeToLineHeight(size));
    default:
      return fontText('normal', theme.fontSize[size || 'base'], mapFontSizeTypeToLineHeight(size));
  }
};

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'block',
    font: ({ size, fontWeight }: LabelProps) => getFontStyle(theme, size, fontWeight || 'normal'),
    color: ({ color }: LabelProps) => color === 'dark' ? theme.color.greys[80] : theme.color.greys[50],
    marginBottom: ({ hasBottomMargin }: LabelProps) => hasBottomMargin ? 24 : 0,
  },
}), { name: 'Label', index: StylesIndexInjections.UI_ATOMS });
